import StoreItem from "./storeItem";

export var display = new StoreItem({
    magnify: null
});